import styled from 'styled-components';
import { filterProps } from 'foundations-components/utils/filterProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
export const getHoverCssStyles = theme => {
  return {
    cursor: 'pointer',
    '&:hover h6': {
      color: theme.color['text-interactive-default']
    }
  };
};
const StyledWrapper = styled.div.withConfig({
  displayName: "FieldGroupWrapper__StyledWrapper",
  componentId: "sc-1vpji7s-0"
})(({
  theme,
  $cssStyles,
  $highlightOnHover
}) => {
  return Object.assign({}, $cssStyles, $highlightOnHover ? getHoverCssStyles(theme) : {}, {
    'div:nth-child(1) > div:nth-child(1) > &:nth-child(1)': {
      borderTop: 'none'
    },
    '& + [data-is-group]': {
      borderTop: 'none'
    },
    '+ [data-field-key]:not([data-is-group])': {
      marginTop: theme.space['400']
    },
    '[data-field-key]:not([data-is-group]) + &': {
      marginTop: theme.space['700']
    }
  });
});
export const FieldGroupWrapper = props => {
  const {
    onClick,
    stretchToSides,
    highlightOnHover
  } = props;
  const {
    tokenProps,
    domProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(Object.assign({
    borderBlockWidth: '100',
    borderBlockColor: 'border-core-default',
    borderBlockStyle: 'solid'
  }, stretchToSides ? {
    marginInline: '-600'
  } : {}, tokenProps));
  return /*#__PURE__*/_jsx(StyledWrapper, Object.assign({
    $cssStyles: cssStyles,
    $highlightOnHover: highlightOnHover,
    "data-is-group": true,
    onClick: onClick
  }, domProps, {
    children: props.children
  }));
};